import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import backendService from '../services/backendService';
import {
  EmailInvitationCreateDTO,
  InvitationRole,
} from '../services/backendService/types';
import { useMetrics } from './useMetrics';
function useInvitation(role: InvitationRole, topic?: unknown, duration?: number) {
  const metrics = useMetrics();
  const client = useQueryClient();
  const { data, isFetching } = useQuery({
    queryKey: [`invitation`, role, topic, duration],
    queryFn: () => backendService.instance.invitations.generate(role, topic, duration),
    staleTime: 1000 * 60 * 50
  });

  const { mutate: bulkInvite, error, isSuccess, isPending: isLoading } = useMutation({
    mutationFn: (val: EmailInvitationCreateDTO[]) => {
      metrics.logEvent('Invite.Email', {
        count: val.length,
        role: val[0] && val[0].role,
      });
      return backendService.instance.invitations.bulkInvite(val);
    },

    onSettled: () => {
      client.invalidateQueries({
        queryKey: ['pending-invitations']
      });
    }
  });

  return {
    url:
      data &&
      `${window.location.origin}/join/${data.code}?utm_medium=link&utm_source=curipod&utm_content=curipod_invitation`,
    isFetching: isFetching,
    bulkInvite,
    error,
    isSuccess,
    isLoading,
  };
}

export default useInvitation;
